import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./assets/css/Header.css"
import "./assets/css/home.css"
import "./assets/css/Style.css"
import "./assets/css/Management.css"

import NotFoundPage from "./404Page";
import ErrorBoundary from "./ErrorBoundary";
import LowercaseRedirect from "./LowercaseRedirect";
import Home from "./home";
import SchoolDetails from "./SchoolDetails";
import CourseDetails from "./CourseDetails";
import CourseDetails2 from "./CourseDetails2";
import CourseDetails3 from "./CourseDetails3";
import CourseDetails4 from "./CourseDetails4";
import CourseDetails5 from "./CourseDetails5";

const App = () => {
  const [isRootEmpty, setIsRootEmpty] = useState(false);

  useEffect(() => {
    const rootDiv = document.getElementById("root");
    if (!rootDiv || rootDiv.innerHTML.trim() === "") {
      setIsRootEmpty(true);
    }
  }, []);

  if (isRootEmpty) {
    return <Navigate to="/404" replace />;
  }

  return (
    <Router>
      <ErrorBoundary>
        {/* Redirect to lowercase if needed */}
        <LowercaseRedirect />
        <Routes>
          {/* Default route */}
          <Route path="/" element={<Home />} />
          {/* Aliases for home */}
          <Route path="/home" element={<Navigate to="/" replace />} />

          {/* Schools */}
          <Route
            path="/school/:schoolName"
            element={<SchoolDetails />}
          />

          <Route path="/course/1" element={<CourseDetails />} />
          <Route path="/course/2" element={<CourseDetails2 />} />
          <Route path="/course/3" element={<CourseDetails3 />} />
          <Route path="/course/4" element={<CourseDetails4 />} />
          <Route path="/course/5" element={<CourseDetails5 />} />

          {/* 404 Handling */}
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </ErrorBoundary>
    </Router>
  );
};

export default App;